import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { startLPTag, liveChatEvents } from './LivePerson/LivePerson';

const LiveChat = ({ brand, language, country, env }) => {
    useEffect(() => {
        startLPTag(brand, language, env, country);

        if (typeof window?.lpTag?.events?.bind === 'function') {
            liveChatEvents.forEach(liveChatEvent => window.lpTag.events.bind(liveChatEvent));
        }

        return () => {
            if (typeof window?.lpTag?.events?.unbind === 'function') {
                liveChatEvents.forEach(liveChatEvent => window.lpTag.events.unbind(liveChatEvent));
            }
        };
    }, []);

    return null;
};

LiveChat.propTypes = {
    brand: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    country: PropTypes.string,
    env: PropTypes.string
};

export default LiveChat;
